import axios from "axios";
export const createUnit = body => {
  return axios.request({
    url: "/api/user/registerUnit",
    method: "post",
    data: body
  });
};
export const getUnitInfo = params => {
  return axios.request({
    url: "/api/unit/info",
    method: "get",
    params
  });
};
export const updateUnitInfo = body => {
  return axios.request({
    url: "/api/unit/update",
    method: "post",
    data: body
  });
};
export const approve = body => {
  return axios.request({
    url: "/api/unit/submitApprove",
    method: "post",
    data: body
  });
};
export const configMode = body => {
  return axios.request({
    url: "/api/ipTables/configMode",
    method: "post",
    data: body
  });
};

// 单位树
export const unitTree = params => {
  return axios({
    url: "/api/gig/unit/tree",
    method: "get",
    params
  });
};

// 单位详情
export const unitDetail = params => {
  return axios({
    url: "/api/gig/unit/detail",
    method: "get",
    params
  });
};

// 单位更新
export const updategigUnitInfo = body => {
  return axios.request({
    url: "/api/gig/unit/update",
    method: "post",
    data: body
  });
};

// 字典表
export const dictList = params => {
  return axios.request({
    url: "/api/codeDict/list",
    method: "get",
    params
  });
};
// POST/api/mfa/unbindByAdmin
export const unbindMFA = body => {
  return axios.request({
    url: "/api/mfa/unbindByAdmin",
    method: "post",
    data: body
  });
};